import { useOrganizations } from '@contexts/organizations-provider';
import { SubmitDocumentPanel } from '@features/documents/components/submit-document-panel/SubmitDocumentPanel';
import { APP_ROUTES } from '@routes/routes.constants';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SubmitDocumentsRoute = React.memo((): React.ReactElement | null => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedOrganization } = useOrganizations();

  const organizationId = selectedOrganization?.id;
  const customerId = selectedOrganization?.customerId;
  const submittedDocumentsPath = APP_ROUTES.MANAGE_DOCUMENTS_SUBMITTED.replace(
    ':customerId',
    customerId ?? ''
  );

  const handleClose = React.useCallback((): void => {
    const parentPath = location.pathname.replace(/\/submit-documents$/, '');

    navigate(parentPath, { replace: true });
  }, [navigate, location.pathname]);

  if (!organizationId) return null;

  return (
    <SubmitDocumentPanel
      isOpen
      onClose={handleClose}
      organizationId={organizationId}
      submittedDocumentsPath={submittedDocumentsPath}
    />
  );
});

SubmitDocumentsRoute.displayName = 'SubmitDocumentsRoute';

export { SubmitDocumentsRoute };
